import { VerificationPinSmsPaymentsComponent } from "./verification-pin/verification-pin-sms-payments.component";
import { VerificationPinComponent } from "./verification-pin/verification-pin.component";
import { VerificationPinSavingsComponent } from "./verification-pin/verification-pin-savings.component";
import { VerificationPinProfileComponent } from "./verification-pin/verification-pin-profile.component";
import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { VerificationSmsCodeComponent } from "./verification-sms-code/verification-sms-code.component";
import { VerificationStartComponent } from "./verification-start/verification-start.component";

const components = [
	VerificationPinComponent,
	VerificationPinSavingsComponent,
	VerificationPinSmsPaymentsComponent,
	VerificationPinProfileComponent,
	VerificationSmsCodeComponent,
	VerificationStartComponent
];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class VerificationCommonModule {}
